export default "__VITE_ASSET__Cqm_R830__"